import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { dateInputDriverFactory as publicDriverFactory } from './DateInput.uni.driver';

export const dateInputPrivateDriverFactory = (base: UniDriver) => {
  return {
    ...publicDriverFactory(base),
    hasDateIcon: () => base.$('[data-hook="date-input-date-icon"]').exists(),
  };
};
